import {Model} from "ords/dist/model/model";

export class AssignmentPartAnswer extends Model {

    // todo doesn't check for type needs to be improved (db wise)
    hasListItem(id) {
        return !!(this.getListItem(id));
    }

    // todo doesn't check for type needs to be improved (db wise)
    getListItem(id) {
        for (const listItem of this.list_items) {
            if (listItem.item_id === id) {
                return listItem;
            }
        }
        return null;
    }

    hasListCheck(id) {
        return !!(this.getListCheck(id));
    }

    getListCheck(id) {
        for (const listCheck of this.list_checks) {
            if (listCheck.item_id === id) {
                return listCheck;
            }
        }
        return null;
    }
}

export const AssignmentPartAnswerModelConfig = {
    name: 'assignmentPartAnswer',
    model: AssignmentPartAnswer,
    relations: [
        {name: 'text', model_name: 'assignmentPartAnswerText', returns_many: false, type: 'hasOne'},
        {name: 'json', model_name: 'assignmentPartAnswerJson', returns_many: false, type: 'hasOne'},
        {name: 'files', model_name: 'assignmentPartAnswerFile', returns_many: true, type: 'hasMany'},
        {name: 'list_items', model_name: 'assignmentPartAnswerListItem', returns_many: true, type: 'hasMany'},
        {name: 'list_checks', model_name: 'assignmentPartAnswerListCheck', returns_many: true, type: 'hasMany'},
    ]
}
